module.exports = __webpack_public_path__ + "media/metronic/_theme/media/products/product10-0cf4d6e0cd114c9e9a67b9cbd02badd4.jpg";